import { render, staticRenderFns } from "./AccidentCount.vue?vue&type=template&id=98dfa8e0&scoped=true"
import script from "./AccidentCount.vue?vue&type=script&lang=js"
export * from "./AccidentCount.vue?vue&type=script&lang=js"
import style0 from "./AccidentCount.vue?vue&type=style&index=0&id=98dfa8e0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dfa8e0",
  null
  
)

export default component.exports